import HttpRequest from '@/plugins/axios'

class UserProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_CENTRAL_API_URL + 'user/')
  }

  async loginJWT(email, password) {
    const { data } = await this.post('/', {
      function: 'login-jwt',
      email: email,
      password: password
    })
    return data
  }

  async getAuthUserInfo(student_id) {
    const { data } = await this.get('/', {
      function: 'get-auth-user-info',
      student_id: student_id
    })
    return data
  }
}

export default UserProvider